// extracted by mini-css-extract-plugin
export default {"talks-publish-button":"GigButton_talks-publish-button__7lFhw"};